/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {
    Modal,
    FormGroup,
    FormControl,
    ControlLabel,
    Button,
    OverlayTrigger,
    Popover
} from 'react-bootstrap';
import {connect} from 'react-redux'

var ComputeServeDialog = React.createClass({

    getInitialState(){
        return {
            namePort: this.props.namePort,
            testResult: "Not Tested",
            serveError: false
        };
    },

    helpPopover(){
        return (
            <Popover id="ComputeServerHelpPopover" title="Compute ServerHelp">
                <p>Use this dialog to set the name/address and optional port
                    number for a remote
                    computation server. </p>
            </Popover>)
    },


    testHandler() {
        // Send test request to server here
        let that = this;
        this.setState(Object.assign({}, this.state, {testResult: "Sending Test Request"}));
        fetch("http://" + this.state.namePort + "/test").then(function (response) {
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                return response.json().then(function (json) {
                    that.setState(Object.assign({}, that.state, {testResult: JSON.stringify(json)}))
                });
            } else {
                that.setState(Object.assign({}, that.state, {testResult: "No JSON sent by server", serveError: true}));
            }

        }).catch(function (error) {
            that.setState(Object.assign({}, that.state, {testResult: error, serveError: true}));
        })
    },

    namePortChange(e) {
        let namePort = e.target.value;
        this.setState(Object.assign({}, this.state, {
            namePort: namePort,
            testResult: "Not Tested",
            serveError: false
        }));
        this.props.assignServer(namePort);
    },

    getValidationState() {
        if (!this.state.serveError) {
            if (this.state.testResult === "Not Tested" || this.state.testResult === "Sending Test Request") {
                return 'warning';
            } else {
                return 'success';
            }

        } else {
            if (this.state.testResult === "Sending Test Request") {
                return "warning;"
            }
            return 'error';
        }
  },

    render(){
        return (
            <Modal show={this.props.open} onHide={this.props.close}
                   dialogClassName="comp-serve-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Compute Server Configuration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <FormGroup validationState={this.getValidationState()} >
                            <ControlLabel>Server Name/Address and optional port
                                number</ControlLabel>
                            <FormControl type="text"
                                         onChange={this.namePortChange}
                                         value={this.state.namePort}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Test Results</ControlLabel>
                            <FormControl componentClass="textarea"

                                         value={this.state.testResult} readOnly
                                         rows={4}/>
                        </FormGroup>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary"
                            onClick={this.testHandler}>Test </Button>
                    <Button onClick={this.props.close}>Close</Button>
                    <OverlayTrigger trigger="click" placement="top"
                                    overlay={this.helpPopover()}>
                        <Button bsStyle={'info'}>Help</Button>
                    </OverlayTrigger>
                </Modal.Footer>
            </Modal>
        )
    }
});

const mapStateToProps = (state) => {
    return {
        open: state.uiState.showComputeServeModal,
        namePort: state.compServe.namePort,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        assignServer: (namePort) => {
            dispatch({type: 'ASSIGN_SERVER', namePort: namePort});
        },
        close: () => {
            dispatch({type: 'CLOSE_COMPUTE_SERVE_DIALOG'});
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ComputeServeDialog)




// WEBPACK FOOTER //
// ./src/ComputeServeDialog.js